<template>
  <div class="catalog-sort">
    <span v-if="screenWidth >= 992" class="catalog-sort__text">
      {{ result.messages.sort }}
    </span>
    <DefButtonSecondary v-if="screenWidth < 992" @click="handlerOpenModal">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.27322 11.6833V3.70726L3.17116 5.80931C2.8768 6.10367 2.39954 6.10367 2.10518 5.80931C1.81082 5.51495 1.81082 5.03769 2.10518 4.74333L5.45463 1.39388C5.59287 1.23272 5.798 1.13062 6.02698 1.13062H6.02855C6.22197 1.13022 6.41552 1.20381 6.5631 1.35139L9.95504 4.74333C10.2494 5.03769 10.2494 5.51495 9.95504 5.80931C9.66068 6.10367 9.18342 6.10367 8.88906 5.80931L6.78075 3.701V11.6833C6.78075 12.0996 6.44327 12.4371 6.02698 12.4371C5.61069 12.4371 5.27322 12.0996 5.27322 11.6833ZM13.1877 6.40697C13.1877 5.99067 12.8503 5.6532 12.434 5.6532C12.0177 5.6532 11.6802 5.99067 11.6802 6.40697V14.383L9.57816 12.281C9.28379 11.9866 8.80654 11.9866 8.51217 12.281C8.21781 12.5753 8.21781 13.0526 8.51217 13.347L11.8616 16.6964C11.9999 16.8576 12.205 16.9597 12.434 16.9597L12.4355 16.9597C12.6289 16.9601 12.8225 16.8865 12.9701 16.7389L16.362 13.347C16.6564 13.0526 16.6564 12.5753 16.362 12.281C16.0677 11.9866 15.5904 11.9866 15.2961 12.281L13.1877 14.3893V6.40697Z"
          fill="#030304"
        />
      </svg>

      {{ getActiveName ?? result.messages.sort }}
    </DefButtonSecondary>
    <div v-else class="sort-items">
      <a
        v-for="item in result.items"
        :href="item.request"
        class="sort-item"
        :class="{
          'sort-item_active': item.active || (!getActiveItem && item.sort === 'property_POPULAR'),
        }"
        rel="nofollow"
        @click.prevent="handlerChangeSort(item)"
      >
        {{ item.name }}
      </a>
    </div>
  </div>
</template>

<script>
import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';
import useScreenWidth from '@use/useScreenWidth';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import useModal from '@use/useModal/useModal';
import CatalogSortModal from '@components/Catalog/CatalogSort/CatalogSortModal.vue';

export default {
  name: 'CatalogSort',
  components: { DefButtonSecondary, DefSelectWrapper },
  props: ['result'],
  data() {
    return {
      screenWidth: useScreenWidth(),
      modal: useModal(),
    };
  },
  computed: {
    getActiveItem() {
      return this.result.items.find((el) => el.active);
    },
    getActiveName() {
      return (
        this.getActiveItem?.name ||
        this.result.items.find((el) => el.sort === 'property_POPULAR')?.name
      );
    },
  },
  methods: {
    handlerChangeSort(item) {
      this.$router.replace(item.request);
      this.$emit('changeSort', item.request);
    },
    handlerOpenModal() {
      this.modal.show(CatalogSortModal, {}, { width: '328px', widthTablet: '400px' });
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-sort {
  display: flex;
  align-items: center;
  position: relative;
  @include point-md {
    white-space: nowrap;
    width: 100%;
  }
  &__text {
    font-weight: 600;
    font-size: rem(14);
    margin-right: 6px;
    @include point-lg {
      margin-right: 16px;
      font-size: 16px;
      line-height: 125%;
    }
  }
  &__item {
    &_active {
      color: var(--color-dark-grey);
    }
  }
  :deep(.def-button-secondary) {
    font-size: 14px;
    text-wrap: nowrap;
    height: 36px;
    padding: 0 14px;
    width: 100%;
    @include point-md {
      height: 42px;
      font-size: 16px;
    }
    svg {
      width: 18px;
      height: 18px;
      margin-right: 4px;
      @include point-md {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.sort-items {
  display: flex;
  align-items: center;
  gap: 16px;
}
.sort-item {
  color: var(--color-golden-browm);
  font-size: 16px;
  font-weight: 600;
  line-height: 125%;
  padding: 4px 8px;
  transition: 0.2s linear background-color, 0.2s linear color;
  &_active {
    color: #5d3f36;
    background-color: #eae3d7;
  }
}
</style>
